import graphql from '@/api/graphql'
import Queries from '@/api/graphql/queries'
import { Extractor } from '@/api/utils'

export default {
  get: ({ reference, ...payload } = {}, options = {}) => {
    let { transform = Extractor } = options

    return graphql.request(Queries[`${reference.onModel}Deadlines`], { id: reference.ref, ...payload }).then(transform)
  },
}
